const PREFIX = '/v1/StateProject/StateProjectFileHousehold'

export const URL = {
  ADD: PREFIX + '/add',
  DEL: PREFIX + '/delete',
  EDIT: PREFIX + '/edit',
  LIST: PREFIX + '/list',
  SIMPLE_LIST: PREFIX + '/listSimple',
  DETAIL: PREFIX + '/view',
  ENABLE: PREFIX + '/able',
  DISABLE: PREFIX + '/disable',
  ORDER: PREFIX + '/order',
  OTHER_INFO_SET: PREFIX + '/qitaxinxi',
  ATTACHMENTS_SET: PREFIX + '/fujian',
  REVIEW_LIST: PREFIX + '/listShenHe',
  TONGJI: PREFIX + '/tongji'
}
